import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetByReferUserId } from '../../service/UserReferService';
import { GetByUserId } from '../../service/UserLevelService';
import { GetEpinsSummaryByUserId } from '../../service/EpinService';

function MyStatus() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode, appUser
  } = useGlobalContext();


  //user refer count
  const id = appUser.id;
  const [referCount, setReferCount] = useState(0);
  const [totalEpinsCount, setTotalEpinsCount] = useState(0);
  const [totalUsedEpinsCount, setTotalUsedEpinsCount] = useState(0);
  const [totalBalanceEpinsCount, setTotalBalanceEpinsCount] = useState(0);


  const fetchReferCount = async () => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, "", 1, 9999, "");
      if (response && response.status === 200) {
        setReferCount(response.total || 0);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load refer count");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReferCount();
  }, []);

  /** epin purchased count */
  const fetchEpinsSummary = async () => {
    try {
      setIsLoading(true);
      const response = await GetEpinsSummaryByUserId(id);
      if (response && response.status === 200) {
        setTotalEpinsCount(response.totalEpins || 0);
        setTotalUsedEpinsCount(response.usedEpins || 0);
        setTotalBalanceEpinsCount(response.balanceEpins || 0);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load epin count");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEpinsSummary();
  }, []);


  //user levels
  const [userLevels, setUserLevels] = useState([]);
  const fetchUserLevelList = async () => {
    try {
      setIsLoading(true);
      const response = await GetByUserId(id, 1, 9999, ""); // high limit, page = 1
      setUserLevels(response.userLevels || []);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserLevelList();
  }, []);

  return (
    <>
      <Helmet>
        <title>My Status | {config.appName}</title>
      </Helmet>
      <div className='container'>

        {/* start of page */}
        <div className='page'>

          <div className='page-heading'>
            <h1>My Status</h1>
             <span><Link to="/"> Dashboard </Link> / My Status List</span>
          </div>

          {/* start of page content */}
          <div className='page-content'>

            {/* start of dashboard counter section */}
            <div className='dashboard-counter-section'>
              <div className='row'>

                <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-red'>
                    <i className="bi bi-person-plus"></i>
                    <span className='counter-value'>{referCount}</span>
                    <b>Total Refers</b>
                  </div>
                </div>

                <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-brown'>
                    <i className="bi bi-file-earmark-post"></i>
                    <span className='counter-value'>{totalEpinsCount}</span>
                    <b>Total Epins</b>
                  </div>
                </div>

                <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-green'>
                    <i className="bi bi-file-earmark-check"></i>
                    <span className='counter-value'>{totalUsedEpinsCount}</span>
                    <b>Used Epins</b>
                  </div>
                </div>

                <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                  <div className='dashboard-counter dashboard-counter-blue'>
                    <i className="bi bi-wallet2"></i>
                    <span className='counter-value'>{totalBalanceEpinsCount}</span>
                    <b>Balance Epins</b>
                  </div>
                </div>

              </div>
            </div>

            {/* My Levels */}
            <div className='row'>
              <div className='col-lg-12 col-md-8 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">
                  {/* start of portal title */}
                  <div className='portal-title-bar'>
                    <h4 className='portal-heading'>My Levels</h4>
                    <ul className='portal-actions d-none'>
                      <li>
                        <Link to='#'>
                          <i className="bi bi-arrow-clockwise"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/* end of portal title */}

                  {/* start of portal body */}
                  <div className='portal-body'>
                    <div className='table-content'>
                      <div className="mobile-scroll">
                        <table className='table table-bordered table-condensed'>
                          <thead>
                            <tr>
                              <th>Level</th>
                              <th>Refer Count</th>
                              <th>Achieve</th>
                              <th>Status</th>
                              <th>Award</th>
                              <th>Award Given date / Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userLevels && userLevels.length > 0 ? (
                              userLevels.map((userLevel) => (
                                <tr key={userLevel.id}
                                  className={
                                    userLevel.status === 'completed'
                                      ? 'status-completed'
                                      : userLevel.status === 'pending'
                                        ? 'status-pending'
                                        : userLevel.status === 'active'
                                          ? 'status-active'
                                          : ''
                                  }>
                                  <td >{userLevel.level.name}</td>
                                  <td>{userLevel.level.referCount}</td>
                                  <td>{userLevel.achieve === 1 ? 'Level Achieved' : 'Level Not Achieved'}</td>
                                  <td>
                                    {userLevel.status.charAt(0).toUpperCase() + userLevel.status.slice(1)}
                                  </td>
                                  <td>{userLevel.giftActual.name}</td>
                                  <td>
                                    {userLevel.status === "completed" ? (
                                      (() => {
                                        const date = new Date(userLevel.givenDate.date);
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const year = date.getFullYear();
                                        const formattedDate = `${day}-${month}-${year}`;
                                        const formattedRemarks = userLevel.remarks
                                          ? userLevel.remarks.charAt(0).toUpperCase() + userLevel.remarks.slice(1)
                                          : '';
                                        return (
                                          <>
                                            {formattedDate}
                                            <br />
                                            <small>{formattedRemarks}</small>
                                          </>
                                        );
                                      })()
                                    ) : userLevel.remarks ? (
                                      (() => {
                                        const formattedRemarks = userLevel.remarks.charAt(0).toUpperCase() + userLevel.remarks.slice(1);
                                        return (
                                          <>
                                            - <br />
                                            <small>{formattedRemarks}</small>
                                          </>
                                        );
                                      })()
                                    ) : (
                                      userLevel.status === "pending" ? "Award not yet given" : "-"
                                    )}
                                  </td>

                                </tr>
                              ))
                            ) : (
                              <tr><td colSpan="9" className="text-center">No members found</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>
            </div>

            {/* end of dashboard counter section */}
          </div>
          {/* end of page content */}

        </div>
        {/* end of page */}

      </div>
    </>
  )
}

export default MyStatus